
//let URL_API = 'http://localhost:3333/';// 
let URL_API = 'https://api.gsconnect.coutodev.com.br/';

export default URL_API;


